import * as React from 'react';
import * as classNames from 'classnames';
import * as autoBind from 'react-autobind';
import Strings from '../../globals/Strings';
import {TextInput, Glyphs, TscButtonType, ControlButton} from '@techsmith/tsc-cloud-style-guide';
import TimeFormatter from '../../utils/TimeFormatter/TimeFormatter';
import InlineInput from '../InlineInput/InlineInput';
import Themeable from '../../types/Themeable';

export default class DeadlineControls extends React.Component<DeadlineControlsProps, {}> {
   constructor(props: DeadlineControlsProps) {
      super(props);
      autoBind(this);
   }

   removeDate(e: any) {
      const {removeDate} = this.props;

      e.stopPropagation();

      if (removeDate) {
         removeDate();
      }
   }

   render() {
      const {themeName, reviewByDate, disabled, innerRef, onClick} = this.props;
      const reviewByDateAsString = reviewByDate ? TimeFormatter.formatDateWithNoLocalTimezoneAdjustment(reviewByDate) : '';
      const clearReviewByDateClasses = classNames('review-by-date-clear-container', {enabled: reviewByDate});
      const deadlineInput = (
         <React.Fragment>
            <TextInput sharedId="review-details-deadline-input" disabled={disabled} themeName={themeName} placeholder={Strings.labels.startReviewModal.reviewDetails.deadline.inputPlaceholder} value={reviewByDateAsString} tabIndex={-1} testId="review-details-deadline-input" readOnly={true}/>
            {reviewByDate && <div className={clearReviewByDateClasses}>
               <ControlButton disabled={disabled} title={Strings.labels.startReviewModal.reviewDetails.deadline.removeTitle} themeName={themeName} buttonType={TscButtonType.floating} glyph={<Glyphs.CircleRemove16x16/>} onClick={this.removeDate} testId="review-details-deadline-delete-button"/>
            </div>}
         </React.Fragment>
      );
      const deadlineDateButton = <ControlButton disabled={disabled} themeName={themeName} buttonType={TscButtonType.secondary} label={Strings.labels.date} testId="review-details-deadline-button" ref={innerRef}/>;

      return (
         <InlineInput middleComponent={deadlineInput} rightComponent={deadlineDateButton} onClick={onClick}/>
      );
   }
}

export interface DeadlineControlsProps extends Themeable {
   reviewByDate: Date;
   disabled?: boolean;
   removeDate(): void;
   innerRef(ref: any): void;
   onClick(): void;
}
